import { render } from "./confirm.vue?vue&type=template&id=01f1b9ce&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"

import "./confirm.vue?vue&type=style&index=0&id=01f1b9ce&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f1b9ce"]])

export default __exports__